module.exports = __webpack_public_path__ + "img/hill35.03b05c13.jpg";